/* eslint-disable max-len */
/**
 * Finnish translations.
 */
export default {
  ACTION: {
    CANCEL: 'Peruuta',
    CONFIRM: 'Vahvista',
    NEW_INVOICE: 'Uusi lasku'
  },
  ERROR: {
    ACCUMULATE_SUBMITTED: 'Virhe kertymän lähettämisessä',
    CANCEL_ACCUMULATION: 'Virhe siirtovelkojen peruuntumisen yhteydessä',
    CANCEL_INVOICE: 'Virhe laskun peruuntuessa',
    COUPON_CANCELED: 'Virhe kuponkia peruutettaessa',
    COUPON_GENERATED: 'Virhe kupongin luomisessa',
    ERROR: 'Virhe',
    INVOICE_SUBMITTED: 'Virhe laskun lähettämisessä'
  },
  HEADER: {
    ACCU_REMUNERATION: 'Acu. korvaus',
    ATTACHMENT: 'Liite',
    CHALLENGE: 'Haaste',
    COUPON: 'Kuponki',
    COUPON_CODE: 'Kuponkikoodi',
    DECISION: 'Päätös',
    MONTH: 'Kuukausi',
    OBSERVATIONS: 'Havainnot',
    REMUNERATION: 'Palkkaus',
    STATE: 'Valtio',
    SUBMISSION_DATE: 'Toimituspäivä'
  },
  LABEL: {
    ACCUMULATE: 'Kerryttää',
    ACCUMULATED: 'Kumulatiivinen',
    ACTIVES: 'Aktiivinen',
    ALL: 'Kaikki',
    BEGIN_DATE: 'Aloituspäivä',
    CANCEL: 'Peruuta',
    CANCEL_ACCUMULATION: 'Peruuta kertyminen',
    CANCEL_COUPON: 'Peruuta kuponki',
    CANCEL_INVOICE: 'Peruuta lasku',
    CLOSE: 'Sulje',
    CODE: 'Koodi',
    CONFIRM: 'Vahvista',
    CONFIRM_ACCUMULATE: 'Kerryttää',
    CONFIRM_COUPON_CREATION: 'Luo kuponki',
    CONFIRM_SUBMIT_INVOICE: 'Lähetä',
    COPY_COUPON_CODE: 'Kopioi koodi',
    COUPON: 'Kuponki',
    COUPON_CODE: 'Kuponkikoodi',
    CURRENT_PERIOD: 'P. corr.',
    DATE: 'Päivämäärä',
    DESCRIPTION: 'Kuvaus',
    END_DATE: 'Loppupäivä',
    FILTER: 'Suodatin',
    GENERATE_COUPON: 'Luo kuponki',
    GO_TO_DETAILS: 'Katso tuotteet',
    INVOICE: 'Lasku',
    MODEL: 'Malli',
    MONEY: 'Raha',
    MONTH: 'Kuukausi',
    NEW_INVOICE: 'Uusi lasku',
    PAYMENT_METHOD: 'Maksutapa',
    PENDING_COUNTERPARTS: 'Vireillä olevat vastineet',
    PENDING_COUNTERPARTS_MODAL_TITLE:
      'On olemassa vastineita, joita ei ole vielä validoitu.',
    PENDING_VALUE: 'Laskutettava määrä',
    PREVIOUS_PERIOD: 'P. ant.',
    REMUNERATION: 'Palkkaus',
    SELECTED_PRODUCTS: 'Valitut tuotteet',
    STATE: 'Valtio',
    SUBMIT_INVOICE_ATTACHMENT: 'Liitteet (PDF)',
    SUBMIT_INVOICE_COMMENT: 'Kommentti',
    SUBMIT_MANUAL_REMUNERATION_INVOICE_VALUE: 'Arvo',
    WITHOUT_PRODUCTS: 'Ei valittuja tuotteita',
    YEAR: 'Vuosi'
  },
  SENTENCE: {
    CANCEL_ACCUMULATION: 'Oletko varma, että haluat peruuttaa kertymän?',
    CANCEL_COUPON: 'Haluatko varmasti peruuttaa kupongin {value}?',
    CANCEL_INVOICE: 'Haluatko varmasti peruuttaa laskun lähettämisen?',
    CANT_GENERATE_COUPON: 'Se ei voi tuottaa kuponkeja.',
    CANT_SUBMIT_REMUNERATION: 'Et voi lähettää laskua.',
    CONFIRM_SUBMIT_COUPON:
      'Tuotat kupongin osoitteeseen {couponValue}. Haluatko viimeistellä tämän operaation?',
    EMPTY_TITLE: 'Ei tuloksia'
  },
  SUCCESS: {
    ACCUMULATE_SUBMITTED: 'Kertyneet korvaukset',
    CANCEL_ACCUMULATION: 'Peruutettu siirtovelka',
    CANCEL_INVOICE: 'Lasku peruutettu',
    COUPON_CANCELED: 'Kuponki peruutettu',
    COUPON_COPIED: 'Kuponkikoodi kopioitu',
    COUPON_GENERATED: 'Kuponki luotu koodilla %{value}',
    INVOICE_SUBMITTED: 'Lähetetty lasku',
    SUCCESS: 'Menestys'
  },
  TOOLTIP: {
    ACCU_REMUNERATION: 'Acu. korvaus',
    ATTACHMENT: 'Liite',
    CHALLENGE: 'Haaste',
    COUPON: 'Kuponki',
    COUPON_CODE: 'Kuponkikoodi',
    DECISION: 'Päätös',
    MONTH: 'Kuukausi',
    OBSERVATIONS: 'Havainnot',
    REMUNERATION: 'Palkkaus',
    STATE: 'Valtio',
    SUBMISSION_DATE: 'Päiväys Toimitettu',
    SWIPE: 'Pyyhkäise vasemmalle nähdäksesi lisää sarakkeita.',
    VIEW_CHALLENGE_DETAILS: 'Katso haasteen yksityiskohdat'
  }
};
